const generateRequestId = (prefix = "td") => {
  const safePrefix = String(prefix).replace(/[^a-zA-Z0-9_-]/g, "").slice(0, 20) || "td";
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return `${safePrefix}-${crypto.randomUUID()}`;
  }
  return `${safePrefix}-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

export { generateRequestId };
